import type { ClickableItem, IsDropdownItem, VisibleItem } from 'layouts/main/sp-header/navigation/models';
import { NavigationItem } from 'layouts/main/sp-header/navigation/NavigationItem';
import { connect } from 'react-redux';
import {
  isQuoteBlotterVisible,
  isSecondaryOrderBlotterVisible,
  isSecondaryTradeBlotterVisible,
  isTradeBlotterVisible,
} from 'state/selectors/common/router';
import type { AppState } from 'state/state.model';

export function PrimaryQuoteBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/quote-blotter"
      label="appHeader.navigation.blotters.primary.orderBlotter"
      dataE2eSuffix="quote-blotter"
      category="Workspace"
      action="My quotes blotter"
      isDropdownItem={isDropdownItem}
      onClick={onClick}
    />
  );
}

export const ConnectedPrimaryQuoteBlotterItem = connect((state: AppState) => ({
  isVisible: isQuoteBlotterVisible(state),
}))(PrimaryQuoteBlotterItem);

export function PrimaryTradeBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/trade-blotter"
      label="appHeader.navigation.blotters.primary.tradeBlotter"
      dataE2eSuffix="trade-blotter"
      category="Workspace"
      action="My trades blotter"
      isDropdownItem={isDropdownItem}
      onClick={onClick}
      title="appHeader.navigation.blotters.primary.tradeBlotter.ariaLabel"
    />
  );
}

export const ConnectedPrimaryTradeBlotterItem = connect((state: AppState) => ({
  isVisible: isTradeBlotterVisible(state),
}))(PrimaryTradeBlotterItem);

export function SecondaryOrdersBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-orders-blotter"
      label="appHeader.navigation.blotters.secondary.orderBlotter"
      dataE2eSuffix="secondary-orders-blotter"
      category="Workspace"
      action="Secondary market orders blotter"
      onClick={onClick}
    />
  );
}

export const ConnectedSecondaryOrdersBlotterItem = connect((state: AppState) => ({
  isVisible: isSecondaryOrderBlotterVisible(state),
}))(SecondaryOrdersBlotterItem);

export function SecondaryTradeBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isDropdownItem={isDropdownItem}
      isVisible={isVisible}
      targetRoute="/secondary-trade-blotter"
      label="appHeader.navigation.blotters.secondary.tradeBlotter"
      dataE2eSuffix="secondary-market-trade-blotter"
      category="Workspace"
      action="Secondary market trades blotter"
      onClick={onClick}
      title="appHeader.navigation.blotters.secondary.tradeBlotter.ariaLabel"
    />
  );
}

export const ConnectedSecondaryTradeBlotterItem = connect((state: AppState) => ({
  isVisible: isSecondaryTradeBlotterVisible(state),
}))(SecondaryTradeBlotterItem);
